import { BASE_URL } from "const/API"
import axios from "utils/axios"

export type HDF5TreeDTO = HDF5DirDTO | HDF5FileDTO

export interface HDF5DirDTO {
  isDir: true
  name: string
  nodes: HDF5TreeDTO[]
  path: string
  dataType: string | null
}

export interface HDF5FileDTO {
  isDir: false
  name: string
  shape: [number]
  path: string
  nbytes: string
  dataType: string | null
}

export async function getHDF5TreeApi(
  path: string,
  workspaceId: number,
): Promise<HDF5TreeDTO[]> {
  const response = await axios.get(
    `${BASE_URL}/hdf5/${path}?workspace_id=${workspaceId}`,
  )
  return response.data
}
